import React from 'react';
import root from 'window-or-global';
import PropTypes from 'prop-types';
// import Helmet from 'react-helmet';
import {withRouter} from 'react-router';
import {Route, Switch, Redirect} from 'react-router';
import SignUpPage from '../../components/mobile/SignUpPage';
import DeviceSelect from '../../components/mobile/DeviceSelect';
import {generateRoutePath} from 'epic-common/src/route';
import ConfirmPage from '../../components/mobile/ConfirmPage';
import GetStarted from '../../components/mobile/GetStarted';
import AndroidDownload from '../../components/mobile/AndroidDownload';

class AndroidView extends React.Component {
    static propTypes = {
        cmsData: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        location: PropTypes.object,
        status: PropTypes.object,
        downloadData: PropTypes.object,
        bowser: PropTypes.object,
        androidLink: PropTypes.string,
        shouldShowGooglePlayStore: PropTypes.bool,
        googlePlayIcon: PropTypes.string
    };

    render() {
        const {isLoggedIn, mobile, tablet, status, bowser, androidLink, shouldShowGooglePlayStore, googlePlayIcon} = this.props;
        const cmsData = this.props.cmsData || {};
        const downloadData = this.props.downloadData || {};

        const hideSignUp = cmsData.createAccount || false;
        const hideDownload = cmsData.hideDownload || false;
        // const tags = [
        //     {itemProp: 'name', content: cmsData.metaTitle},
        //     {itemProp: 'description', content: cmsData.metaDescription},
        //     {itemProp: 'image', content: cmsData.metaImage},
        //     {name: 'description', content: cmsData.metaDescription},
        //     {name: 'twitter:title', content: cmsData.metaTitle},
        //     {name: 'twitter:description', content: cmsData.metaDescription},
        //     {name: 'twitter:image', content: cmsData.metaImage},
        //     {property: 'og:title', content: cmsData.metaTitle},
        //     {property: 'og:image', content: cmsData.metaImage},
        //     {property: 'og:description', content: cmsData.metaDescription}
        // ];

        const isAndroid = bowser.android;
        const osVersion = bowser.osversion;
        const isMobile = mobile || tablet;
        const download = !hideDownload;

        //check if Samsung Devices with useragent
        const {userAgent} = root.navigator;
        const supportedGalaxyModels = /(SM-(G9[3-9]|N[89][5-9]|T[89][0-9]|)[0-9]|SC-0[1-3]|SCV[34][0-9])/;
        const isSamsung = supportedGalaxyModels.test(userAgent);

        //redirects to correct download link
        let redirect = generateRoutePath('/mobile/android/sign-up');
        const location = this.props.location || {};
        const search = location.search || '';
        if (hideSignUp && !download) {
            redirect = generateRoutePath('/page-not-found');
        } else if (hideSignUp) {
            redirect = generateRoutePath('/mobile/android/get-started');
        }

        return (
            <div className="android-view" data-osversion={osVersion}>
                {/* <Helmet meta={tags} title={cmsData.metaTitle} /> */}
                <Switch>
                    {!hideSignUp
                        ? [
                              <Route key="AndroidSignup" path="/:path/:locale/mobile/android/sign-up">
                                  <SignUpPage
                                      android
                                      downloadActive={download}
                                      isSamsung={isSamsung}
                                      title={cmsData.title}
                                      isLoggedIn={isLoggedIn}
                                      content={cmsData.signup}
                                      mobile={mobile}
                                      tablet={tablet}
                                      location={location}
                                      status={status}
                                  />
                              </Route>,
                              <Route key="androidDeviceSelect" path="/:path/:locale/mobile/android/device-select">
                                  <DeviceSelect
                                      android
                                      content={cmsData.device}
                                      isLoggedIn={isLoggedIn}
                                      status={status}
                                      title={cmsData.title}
                                  />
                              </Route>,
                              <Route key="androidConfirm" path="/:path/:locale/mobile/android/confirm">
                                  <ConfirmPage android content={cmsData.confirm} title={cmsData.title} status={status} />
                              </Route>
                          ]
                        : null}
                    {download
                        ? [
                              <Route key="androidGetStarted" path="/:path/:locale/mobile/android/get-started">
                                  <GetStarted
                                      data={downloadData.getStarted}
                                      mobile={isMobile}
                                      isSamsung={isSamsung}
                                      samsungData={downloadData.samsung}
                                      supportedDevices={downloadData.supportDevices}
                                      isAndroid={isAndroid}
                                      osVersion={osVersion}
                                      shouldShowGooglePlayStore={shouldShowGooglePlayStore}
                                      googlePlayIcon={googlePlayIcon}
                                  />
                              </Route>,
                              <Route key="androidNewDevice" path="/:path/:locale/mobile/android/new-device">
                                  <AndroidDownload
                                      newFlow
                                      supportedDevices={downloadData.supportDevices}
                                      isSamsung={isSamsung}
                                      samsungData={downloadData.samsung}
                                      osVersion={osVersion}
                                      data={downloadData.newDevices}
                                      link={androidLink}
                                      isAndroid={isAndroid}
                                  />
                              </Route>,
                              <Route key="androidOldDevice" path="/:path/:locale/mobile/android/old-device">
                                  <AndroidDownload
                                      oldFlow
                                      supportedDevices={downloadData.supportDevices}
                                      isSamsung={isSamsung}
                                      samsungData={downloadData.samsung}
                                      osVersion={osVersion}
                                      isAndroid={isAndroid}
                                      link={androidLink}
                                      data={downloadData.oldDevices}
                                  />
                              </Route>,
                              <Route key="androidNotSupported" path="/:path/:locale/mobile/android/not-supported">
                                  <AndroidDownload
                                      notSupported
                                      osVersion={osVersion}
                                      isAndroid={isAndroid}
                                      link={androidLink}
                                      data={downloadData.notSupported}
                                  />
                              </Route>,
                              <Route key="androidDownload" path="/:path/:locale/mobile/android/download">
                                  <Redirect
                                      to={{
                                          pathname: redirect,
                                          search
                                      }}
                                  />
                              </Route>
                          ]
                        : null}
                    <Route path="/:path/:locale/mobile/android">
                        <Redirect
                            to={{
                                pathname: redirect,
                                search
                            }}
                        />
                    </Route>
                </Switch>
            </div>
        );
    }
}

export default withRouter(AndroidView);
